<template>
  <div class="register-body">
    <a-result
    status="success"
    :title="$t('scope.text_352')"
    :subTitle="title">
    <template v-slot:extra>
      <a-button type="primary" @click="login">{{$t('scope.text_353')}}</a-button>
    </template>
  </a-result>
  </div>
</template>

<script>

export default {
  name: 'RegisterResult',
  data () {
    let title = this.$t('auth.register.oauth.success')
    if (this.$route.query.user_name) {
      title = this.$t('scope.text_354', [this.$route.query.user_name])
    }
    return {
      title: title,
    }
  },
  methods: {
    login () {
      this.$router.push({
        path: 'login',
        query: {
          ...this.$route.query,
          userName: `${this.$route.query.user_name}`,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>

.register-body {
  width: 570px;
  height: 680px;
  position: relative;
  background-color: #fff;
  padding: 40px;
  ::v-deep {
    .ant-input-group-addon {
      border: 0;
    }
  }
}
</style>
